// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.skill-form__upload-certif-btn.post-form__field {\n  margin: 0;\n}\n", ""]);
// Exports
module.exports = exports;
